(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/fp/unset', '../util/lodashFpConvert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/fp/unset'), require('../util/lodashFpConvert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.unset, global.lodashFpConvert);
    global.unset = mod.exports;
  }
})(this, function (exports, _unset2, _lodashFpConvert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.unset = undefined;

  var _unset3 = _interopRequireDefault(_unset2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Removes the property at <code>path</code> of <code>object</code>.
   * This is the <code>lodash/fp</code> <code>unset</code>, with no arguments rearranging and no currying.
   * @function
   * @memberof object
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to unset.
   * @return {Object} Returns the updated object.
   * @example unset({ nested: { prop: 'value' } }, 'nested.prop') // => { nested: {} }
   * @see {@link https://lodash.com/docs#unset|lodash.unset} for more information.
   * @since 0.1.5
   */
  var unset = (0, _lodashFpConvert.lodashFpConvert)(_unset3.default);
  exports.unset = unset;
  exports.default = unset;
});